<template>
  <div class="searchpanel mw-100 cl-accent" :class="{ 'show-category-for-iphone' : !categoryShow }"
       data-testid="searchPanel" ref="searchpanel"
  >
    <div class="brd-btm">
      <div class="container">
        <div class="row flex">
          <div class="col-md-12 col-xs-12 flex">
            <div class="pointer mr10" @click="toggleSearchpanel">
              <i class="material-icons search-icon">search</i>
            </div>
            <template v-if="isLoadingCategory">
              <div class="inline-flex middle-xs relative mx5 my5 skeleton" v-for="index in 6" :key="index" />
            </template>
            <product-category @showCategory="showCategory" />
          </div>
          <div class="close-icon-row" />
        </div>
      </div>
    </div>
  </div>
</template>

<script async>
import SearchPanel from '@vue-storefront/core/compatibility/components/blocks/SearchPanel/SearchPanel'
import VueOfflineMixin from 'vue-offline/mixin'
import { minLength } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'

const ProductCategory = () => import(/* webpackChunkName: "vsf-product-category" */ 'theme/components/core/blocks/ProductCategory');

export default {
  components: {
    ProductCategory
  },
  mixins: [SearchPanel, VueOfflineMixin],
  validations: {
    search: {
      minLength: minLength(3)
    }
  },
  data () {
    return {
      selectedCategoryIds: [],
      isOpenSearch: false,
      categoryShow: false
    }
  },
  computed: {
    showClose () {
      return this.search
    },
    showPanel () {
      return this.isOpen && this.componentLoaded
    },
    ...mapGetters({
      partner: 'partners/getCurrentPartner',
      isLoadingCategory: 'category/getListLoader'
    })
  },
  methods: {
    toggleSearchpanel () {
      this.$store.commit('ui/setSearchpanel', !this.isOpen)
    },
    showCategory (e) {
      this.categoryShow = e;
    }
  },
  destroyed () {
    localStorage.setItem(`shop/user/searchQuery`, this.search ? this.search : '');
  }
}
</script>

<style lang="scss" scoped>
@import "~theme/css/animations/transitions";
@import "~theme/css/variables/grid";
@import "~theme/css/variables/typography";

.skeleton {
  background-color: #F0F0EE;
  min-width: 64px;
  height: 35px;
  border-radius: 35px;
  padding: 0 20px;
}

.searchpanel.mt50 {
  margin-top: 50px;
}
.show-category-for-iphone{
  overflow-y: scroll;
  overflow-x: hidden;
}
.searchpanel {
  position: relative;
  top: -50px;
  max-height:85vh ;
  height: auto;
  width: 100%;
  z-index: 2;
  padding: 0 24px;

  -webkit-overflow-scrolling: touch;
  @media (max-width: 425px) {
    right: 0;
  }
  .container{
    @media(max-width:1200px){
      width:100%;
      padding-right:0;
    }
  }

  .close-icon-row {
    position: absolute;
    right: map-get($grid-gutter-widths, lg) / 2;
    top: 0;

    @media #{$media-xs} {
      right: map-get($grid-gutter-widths, xs) / 2;
    }
  }

  .brd-btm{
    position: sticky;
    top: 0;
    z-index: 2;
  }

  .row {
    margin-left: - map-get($grid-gutter-widths, lg) / 2;
    margin-right: - map-get($grid-gutter-widths, lg) / 2;

    @media #{$media-xs} {
      margin-right: - map-get($grid-gutter-widths, xs) / 2;
      margin-left: - map-get($grid-gutter-widths, xs) / 2;
    }
  }

  .col-md-12 {
    position: relative;
    height: 45px;
  }
  .product-listing-wrapper{
    left: 0;
    right: 0;
    position: sticky;
  }

  .product-listing > div {
    padding-top: 30px;
  }

  .product {
    box-sizing: border-box;
    width: 25%;
    padding-left: map-get($grid-gutter-widths, lg) / 2;
    padding-right: map-get($grid-gutter-widths, lg) / 2;

    @media #{$media-xs} {
      width: 50%;
      padding-left: map-get($grid-gutter-widths, xs) / 2;
      padding-right: map-get($grid-gutter-widths, xs) / 2;
    }
  }

  .close-icon {
    padding: 8px 15px;
  }

  .search-input-group {
    display: flex;
  }

  .search-icon {
    height: 40px;
    width: 40px;
    display: flex;
    padding: 0;
    margin-top: 2.5px;
    border-radius: 50%;
    align-items: center;
    justify-content: center;
    color: #fff;
    background-color: #11bb2e;
    margin-left: -2px;
    @media #{$media-xs} {
      justify-content: left;
    }
    @media (max-width: 768px) {
      justify-content: center;
    }
  }

  .search-panel-input::-ms-clear{
    display: none;
  }
  .search-panel-input::-webkit-search-cancel-button {
    display: none;
    -webkit-appearance: none;
  }

  .search-panel-input {
    -webkit-appearance:none;
    height: 40px;
    line-height: 40px;
    width: calc(100% - 40px);
    padding-left: 15px;
    border: none;
    outline: 0;
    color: #999999;
    font-size: 18px;
    margin-bottom: 10px;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    font-family: map-get($font-families, primary);

    @media #{$media-xs} {
      font-size: 16px;
    }
  }

  .no-results {
    padding-bottom: 30px;
    width: 100%;
  }

  i {
    opacity: 1;
  }

  i:hover {
    opacity: 1;
  }

  .close-button {
    background: #fff;
  }

  button {
    @media #{$media-xs} {
      width: 100%;
      margin-bottom: 15px;
    }
  }
}
</style>
